import AppendixForm from "../AppendixForm/AppendixForm";

export default function CreateAppendixForm({ onClose }) {
	return <AppendixForm onClose={onClose} />;
}
